import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from './core/services/storage.service';
import { PrimeNG } from 'primeng/config';
import { ServiceWorkerService } from './core/services/serviceworker.service';
import { AuthService } from './auth/services/auth.service';
import { LoadingService } from './core/loading/services/loading.service';
import { ConfigService } from './core/services/config.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'cropmap_app';
  selectedLang: string = 'EN';
  lang: string = 'en';

  constructor(
    private storage: StorageService,
    private translate: TranslateService,
    private config: PrimeNG,
    private translateService: TranslateService,
    private serviceWorkerService: ServiceWorkerService,
    private authService: AuthService,
    private storageService: StorageService,
    private loadingService: LoadingService,
    private configService: ConfigService,
  ) {
    this.serviceWorkerService.checkForUpdates();
  }

  private supportedLangs = ['en', 'tr', 'es'];

  ngOnInit() {
    let lang = this.storage.Get('lang');
    if (!lang) {
      const browserLang = navigator.language?.split('-')[0]?.toLowerCase();
      lang = this.supportedLangs.includes(browserLang) ? browserLang : 'en';
      this.storage.Set('lang', lang);
    }
    this.translate.setDefaultLang(lang);
    this.translateService.get('primeng').subscribe((res) => this.config.setTranslation(res));
  }
}

